import React from 'react'
import './Header.css'
import { Avatar } from '@mui/material'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SearchIcon from '@mui/icons-material/Search';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LogoutIcon from '@mui/icons-material/Logout';
import { useStateValue } from "./StateProvider"

import { auth } from "./firebase"
import { actionTypes } from "./reducer"

import Popup from 'reactjs-popup';

 
function Header() {
const [state, dispatch] = useStateValue()
const [{ user }] = useStateValue()

   
const signOut = () => {
  auth.signOut()
  .then(() => { 
    dispatch({
      type: actionTypes.SET_USER,
      user: null
  }) 
  })
  .catch(error => {
    alert(error.message)
})
}

return (
    <div className='header'>
        <div className="header__left">
        <Avatar 
        className='header__avatar'
        alt={user?.displayName}
        src={user?.photoURL}
        />
        
        <Popup trigger={
          <AccessTimeIcon />
        }
        on={['hover', 'focus']}
        >
          <div className="header__popupContent">
              <p>The current server time is: {new Date().toUTCString()}
              </p>
              </div>
        </Popup>
        
        
        </div>

        <div className="header__search">
        <SearchIcon />
          <input type="text" placeholder='Search the app' />
        </div>
        <div className="header__right">
          
          <Popup trigger={
            <HelpOutlineIcon className='header__right-infoIcon'/>
          }
            on={['hover', 'focus']}
            >
            <div className="header__popupContent">
              <p>~Wav Pool~ is built with ReactJS, Material UI, Firebase, manages state with React Context API, npm reactjs-popup.
              </p>
            </div>
          </Popup>
           


        <LogoutIcon onClick={signOut}/>
        </div>
    </div>
  )
}

export default Header